/**
 * ZalandoService — STUB v1.12.485 (RapidAPI désactivé)
 * Retourne des arrays vides pour ne plus consommer le quota RapidAPI.
 * Pour réactiver : git restore depuis commit pré-v1.12.485.
 */
export async function getZalandoProducts() { return []; }
export function matchWithWardrobe(products) { return products || []; }
export function getFallbackProducts() { return []; }
